import { slices } from '~/redux/slices';
import { ActiveModal } from '~/redux/slices/eSignature/types';
import { useAppDispatch, useAppSelector } from '~/rootState';

export const useIntegrationsModalController = (onRefetch?: () => void) => {
  const dispatch = useAppDispatch();
  const integrationData = useAppSelector(
    (state) => state.esignatureIntegration.integrationData,
  );

  const activeModal = useAppSelector(
    (state) => state.esignatureIntegration.activeIntegrationModal,
  );
  const activeModalData =
    integrationData[activeModal?.integrationId as keyof typeof integrationData];

  const selectedUsers = useAppSelector(
    (state) => state.esignatureIntegration.selectedUsers,
  );

  const selectedUserCount = useAppSelector(
    (state) => state.esignatureIntegration.selectedUsers.length,
  );

  const closeModal = () =>
    dispatch(slices.esignature.actions.setActiveModal(null));

  const clearSelectedUsers = () =>
    dispatch(slices.esignature.actions.clearSelectedUsers());

  const setModalState = (payload: ActiveModal) => {
    dispatch(slices.esignature.actions.setActiveModal(payload));
  };

  const closeAndClearSelectedUsers = () => {
    closeModal();
    clearSelectedUsers();
  };

  return {
    activeModal,
    activeModalData,
    closeModal,
    clearSelectedUsers,
    closeAndClearSelectedUsers,
    setModalState,
    selectedUsers,
    selectedUserCount,
    onRefetch,
  };
};
